import React from 'react'
import { VStack, Text, HStack, Spinner } from '@chakra-ui/react'
import { ReactComponent as Logo } from '../../assets/logo.svg'

function Loader(): JSX.Element {
  return (
    <VStack justifyContent={'center'} align={'center'} height={'100vh'}>
      <Logo width={'40%'} />
      <HStack>
        <Spinner />
        <Text>Loading...</Text>
      </HStack>
    </VStack>
  )
}

export { Loader }
